import utils from '../../../utils'
import { isTipoBoletoAilos, isTipoBoletoCnab, isTipoBoletoSicoob } from '../../../utils/tipo-boleto-utils'
import { isTipoBancoBanrisul } from '../../../utils/tipo-banco-utils'

export function validate(record) {
  const errors = []

  const parseNonNegativeInteger = (value) => {
    if (value == null) return null

    if (typeof value === 'number') {
      if (!Number.isFinite(value) || !Number.isInteger(value)) return null
      return value >= 0 ? value : null
    }

    const str = String(value).trim()
    if (!str) return null
    if (!/^\d+$/.test(str)) return null

    const parsed = parseInt(str, 10)
    return Number.isNaN(parsed) ? null : parsed
  }

  if (!record.tipoBoleto || !record.tipoBoleto.id) {
    errors.push({ field: 'tipoBoleto', message: 'O campo tipo boleto é obrigatório!' })
  }

  if (!record.codigoBanco || !record.codigoBanco.id) {
    errors.push({ field: 'codigoBanco', message: 'O campo código banco é obrigatório!' })
  }

  if (!record.nome || String(record.nome).trim() === '') {
    errors.push({ field: 'nome', message: 'O campo nome é obrigatório!' })
  }

  const numeroConvenioCobrancaInt = parseNonNegativeInteger(record.numeroConvenioCobranca)
  if (numeroConvenioCobrancaInt == null) {
    errors.push({ field: 'numeroConvenioCobranca', message: 'O campo número convênio cobrança é obrigatório!' })
  }

  const codigoCarteiraCobrancaInt = parseNonNegativeInteger(record.codigoCarteiraCobranca)
  if (codigoCarteiraCobrancaInt == null) {
    errors.push({ field: 'codigoCarteiraCobranca', message: 'O campo código carteira cobrança é obrigatório!' })
  }

  if (!record.especieDocumento || !record.especieDocumento.id) {
    errors.push({ field: 'especieDocumento', message: 'O campo espécie documento é obrigatório!' })
  }

  const exigeDocumentoEmissao = isTipoBoletoAilos(record.tipoBoleto)
  if (exigeDocumentoEmissao) {
    if (!record.numeroDocumento || String(record.numeroDocumento).trim() === '') {
      errors.push({ field: 'numeroDocumento', message: 'O campo número documento é obrigatório!' })
    }

    if (!record.dataEmissao) {
      errors.push({ field: 'dataEmissao', message: 'O campo data emissão documento é obrigatório!' })
    }

    if (record.numeroParcelas == null || String(record.numeroParcelas).trim() === '') {
      errors.push({ field: 'numeroParcelas', message: 'O campo número parcelas é obrigatório!' })
    }
  }

  const exigeFormaEmissao =
    isTipoBoletoAilos(record.tipoBoleto) ||
    isTipoBoletoSicoob(record.tipoBoleto) ||
    (isTipoBoletoCnab(record.tipoBoleto) && isTipoBancoBanrisul(record.codigoBanco))

  if (exigeFormaEmissao && (!record.formaEmissao || !record.formaEmissao.id)) {
    errors.push({ field: 'formaEmissao', message: 'O campo forma emissão é obrigatório!' })
  }

  if (typeof record.valorMinimoPagamentoDivergente === 'string') {
    record.valorMinimoPagamentoDivergente = record.valorMinimoPagamentoDivergente
      .replace('R$', '')
      .replace(/\./g, '')
      .replace(',', '.')
  }
  if (typeof record.valorDesconto === 'string') {
    record.valorDesconto = record.valorDesconto.replace('R$', '').replace(/\./g, '').replace(',', '.')
  }
  if (typeof record.valorMulta === 'string') {
    record.valorMulta = record.valorMulta.replace('R$', '').replace(/\./g, '').replace(',', '.')
  }

  if (typeof record.valorJurosMora === 'string') {
    record.valorJurosMora = record.valorJurosMora.replace('R$', '').replace(/\./g, '').replace(',', '.')
  }

  if (typeof record.percentualDesconto === 'string') {
    record.percentualDesconto = record.percentualDesconto.replace('%', '').replace(/\./g, '').replace(',', '.')
  }

  if (typeof record.percentualMulta === 'string') {
    record.percentualMulta = record.percentualMulta.replace('%', '').replace(/\./g, '').replace(',', '.')
  }

  if (typeof record.percentualJurosMora === 'string') {
    record.percentualJurosMora = record.percentualJurosMora.replace('%', '').replace(/\./g, '').replace(',', '.')
  }

  utils.blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }

  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
